<template>
  <div v-if="restaurantId !== -1" id="products-tabs" class="tab-content">

    <add-product-sidebar :isSidebarActive="addNewDataSidebar" @getProductList="getProductList" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <div class="products user-search-section">
      <div @click="addNewData" class="tr-button blue-button"><i class="fas fa-plus"></i> Add New Product</div>
      <div class="user-search-bar">
        <input class="tr-input" type="text" v-model="searchString" placeholder="Search product..."/>
        <span class="text-danger text-sm ml-4" v-show="searchString !== '' && !searchedProducts.length > 0">No result</span>
      </div>
      <v-select class="" placeholder="Select a Category" v-model="selected_section"
                :options="section_options" :clearable="true" @input="searchProducts"/>
      <div class="user-search-button">
        <div class="tr-button blue-button" @click="searchProducts">Search</div>
      </div>
      <div class="">
        <input id="toggle-sort-date" type="checkbox" v-model="sort_by_date" />
        <label for="toggle-sort-date" class="">Show Latest On Top</label>
      </div>
    </div>
    <div id="menu-category" class="menu-list products">
      <div class="menu-list-item heading">
        <div class="menu-list-item-column">Product Image</div>
        <div class="menu-list-item-column">Product Name</div>
        <div class="menu-list-item-column">Category Name</div>
        <div class="menu-list-item-column">Product Price</div>
        <div class="menu-list-item-column">Actions</div>
      </div>
      <div v-for="product in displayList" :key="product.id" class="menu-list-item">
<!--const {name, id, price, description, restaurant_id, size, section, size_id, section_id, hasModifiers, photoUrl, complete_your_meal} = this.data        -->
        <div class="menu-list-item-column"><img :src="product.photoUrl" v-if="product.photoUrl !== null"/> <div v-else>No Image</div></div>
        <div class="menu-list-item-column">{{ product.name }}</div>
        <div class="menu-list-item-column">{{ product.section ? product.section.name : '' }}</div>
        <div class="menu-list-item-column">${{ product.size_min_price }}</div>
        <div class="menu-list-item-column">
          <div @click="duplicateData(product)" class="list-button"><i class="fas fa-copy"></i> Duplicate</div>
          <div @click="editData(product)" class="list-button"><i class="fas fa-edit"></i>Edit</div>
          <div @click.stop="confirmDelete(product.id)" class="list-button"><i class="fas fa-trash"></i>Delete</div>

        </div>
      </div>
    </div>

    <div class="pagination flex" v-if="displayListSource.length > itemCount">
      <div @click="pageDown">&laquo;</div>
      <div class="cursor-pointer" @click="pageCount = page - 1" v-for="(page, index) in pageArray" :key="index" :class="page === pageCount + 1 ? 'active' : ''">{{page}}</div>
      <div @click="pageUp">&raquo;</div>
    </div>
  </div>
  <div v-else>
    Please select a restaurant
  </div>
</template>

<script>
import AddProductSidebar from './AddProductSidebar'
import vSelect from 'vue-select'

export default {
  props: {
    restaurantId: {
      type: Number,
      default () {
        return -1
      }
    }
  },
  watch: {
    restaurantId (newVal) { // watch it
      this.restaurantId = newVal
      this.getSectionList()
      this.getSizeList()
      this.getModifierList()
      this.getProductList()
    },
    searchString () {
      this.searchProducts()
    },
    selected_section () {
      if (!this.selected_section) {
        this.selected_section = {label:'Filter by section', value: -1}
      }
    },
    sort_by_date () {
      this.$store.commit('api/SET_ORDER_BY', this.sort_by_date)
    }
  },
  components: {
    AddProductSidebar,
    'v-select': vSelect
  },
  data () {
    return {
      addNewDataSidebar: false,
      sort_by_date: false,
      sidebarData: {},
      resId: '',
      itemsPerPage: 20,
      selected: [],
      section_options: [],
      selected_section: {label:'Filter by section', value: -1},
      searchedProducts: [],
      searchString: '',
      pageCount: 0,
      itemCount: 10,
      content_type: null
    }
  },
  mounted () {
    this.sort_by_date = this.order_by_date

  },
  beforeMount () {
    this.resId = this.restaurantId
    this.getSectionList()
    this.getSizeList()
    this.getModifierList()
    this.getProductList()
  },
  methods: {
    pageUp () {
      if (this.pageCount < this.max_page) {
        this.pageCount += 1
      }
    },
    pageDown () {
      if (this.pageCount !== 0) {
        this.pageCount -= 1
      }
    },
    filterProducts (product, query, selectedSection) {
      if (!selectedSection || selectedSection.value === -1) {
        return product.name.toLowerCase().includes(query.toLowerCase()) || product.section.name.toLowerCase().includes(query.toLowerCase())
      } else {
        return (product.name.toLowerCase().includes(query.toLowerCase()) || product.section.name.toLowerCase().includes(query.toLowerCase())) && product.section.id === selectedSection.value
      }
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    searchProducts () {
      this.pageCount = 0
      this.searchedProducts = this.productlist.filter((product) => this.filterProducts(product, this.searchString, this.selected_section))
    },
    addNewData () {
      this.sidebarData = {}
      this.sidebarData.add = true
      this.sidebarData.restaurantId = this.restaurantId
      this.sidebarData.section_options = this.getSectionOptionsList()
      this.sidebarData.size_options = this.getSizeOptionsList()
      this.sidebarData.modifier_options = this.getModifierOptionsList()
      this.toggleDataSidebar(true)
    },
    duplicateData (data) {
      data.id = null
      this.sidebarData = data
      this.sidebarData.section_options = this.getSectionOptionsList()
      this.sidebarData.size_options = this.getSizeOptionsList()
      this.sidebarData.modifier_options = this.getModifierOptionsList()
      this.toggleDataSidebar(true)
    },
    editData (data) {
      this.sidebarData = data
      this.sidebarData.section_options = this.getSectionOptionsList()
      this.sidebarData.size_options = this.getSizeOptionsList()
      this.sidebarData.modifier_options = this.getModifierOptionsList()
      this.toggleDataSidebar(true)
    },
    getModifierList () {
      // Loading

      const payload = {
        restaurantId: this.restaurantId
      }

      this.$vs.loading()

      this.$store.dispatch('api/getModifierList', payload)
        .then(() => {
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getSectionList () {
      // Loading

      const payload = {
        restaurantId: this.restaurantId
      }

      this.$vs.loading()

      this.$store.dispatch('api/getSectionList', payload)
        .then(() => {
          this.$vs.loading.close()

          this.section_options = this.getSectionOptionsList()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getSizeList () {
      // Loading

      const payload = {
        restaurantId: this.restaurantId
      }

      this.$vs.loading()

      this.$store.dispatch('api/getSizeList', payload)
        .then(() => {
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getProductList () {
      // Loading

      const payload = {
        restaurantId: this.restaurantId
      }

      this.$vs.loading()

      this.$store.dispatch('api/getProductList', payload)
        .then(() => {
          this.searchProducts()
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getSectionOptionsList () {
      const list = this.sectionlist
      const opt_list = []
      if (list !== 'undefined') {
        list.forEach(function (key, value) {
          opt_list.push({label: key.name, value: key.id, value2: value})
        })

      }

      return opt_list
    },
    getSizeOptionsList () {
      const list = this.sizelist
      const opt_list = []
      if (list !== 'undefined') {
        list.forEach(function (key, value) {
          opt_list.push({label: key.name, value: key.id, value2: value})
        })
      }

      return opt_list
    },
    getModifierOptionsList () {
      const list = this.modifierlist
      const opt_list = []
      if (list !== 'undefined') {
        list.forEach(function (key, value) {
          const key_id = key.id
          opt_list[String(key_id)] = {label: key.name, value: key.id, value2: value}
        })
      }
      return opt_list
    },
    deleteData (parameters) {
      const obj = {
        restaurantId: this.restaurantId,
        productId: parameters[0]
      }
      this.$store.dispatch('api/removeProduct', obj).then(() => {
        this.$vs.notify({
          title: 'Delete',
          text: 'Item deleted succesfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
        this.getProductList()
      }).catch(err => { console.error(err) })
    },
    confirmDelete (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure to delete this item?',
        clickNotClose: true,
        accept: this.deleteData,
        parameters: [id],
        acceptText: 'Delete'
      })

    }
  },
  computed: {
    max_page () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      const max_page = Math.floor(array.length / this.itemCount)
      return max_page
    },
    pageArray () {
      const array = JSON.parse(JSON.stringify(this.displayListSource))
      const page_array = []
      let i = 0
      const max_page = Math.floor(array.length / this.itemCount)
      const kalan = array.length % this.itemCount
      for (i = 0; i < max_page; i++) {
        page_array.push(parseInt(i) + 1)
      }
      if (kalan > 0) {
        page_array.push(max_page + 1)
      }
      return page_array
    },
    displayList () {
      let array = JSON.parse(JSON.stringify(this.displayListSource))
      if (this.sort_by_date) {
        array = array.sort((a, b) => {
          // Turn your strings into dates, and then subtract them
          // to get a value that is either negative, positive, or zero.
          return new Date(b.created_date) - new Date(a.created_date)
        })
      }
      return array.splice(this.pageCount * this.itemCount, this.itemCount)
    },
    displayListSource () {
      return this.searchedProducts.length > 0 ? this.searchedProducts : this.productlist
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.sectionlist.length
    },
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    sectionlist () {
      return this.$store.state.api.sectionlist
    },
    order_by_date () {
      return this.$store.state.api.order_by_date
    },
    sizelist () {
      return this.$store.state.api.sizelist
    },
    productlist () {
      return this.$store.state.api.productlist
    },
    modifierlist () {
      return this.$store.state.api.modifierlist
    }
  }
}
</script>

<style lang="scss">
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 10px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
</style>
